<template>
  <div>
    <component-header
      title="Change Password"
      :hasCreate="false"
      :hasSearch="false"
      :hasReload="false"
    />
    <div class="account-pages">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <div class="card">
              <div class="card-body p-4">
                <ValidationObserver v-slot="{ invalid }">
                  <div class="form-group ">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Old Password"
                    >
                      <eb-input
                        lable="Old Password"
                        id="oldpassword"
                        placeholder="Enter Old password"
                        v-model="oldPwd"
                        type="password"
                        name="oldpassword"
                        validation="required"
                      ></eb-input>
                      <span class="validate-error text-primary">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group ">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="New Password"
                    >
                      <eb-input
                        lable="New Password"
                        id="newpassword"
                        placeholder="Enter New password"
                        v-model="newPwd"
                        type="password"
                        name="newpassword"
                        validation="required"
                      ></eb-input>
                      <span class="validate-error text-primary">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group ">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Confirm Password"
                    >
                      <eb-input
                        lable="Confirm Password"
                        id="confirmpassword"
                        placeholder="Confirm your new password"
                        v-model="cfmPwd"
                        type="password"
                        name="confirmpassword"
                        validation="required"
                      ></eb-input>
                      <span class="validate-error text-primary">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group mb-4 text-center">
                    <button
                      @click.prevent="onSubmit"
                      type="submit"
                      class="btn btn-solid btn-primary mt-3"
                      :disabled="invalid"
                    >
                      Submit
                    </button>
                  </div>
                </ValidationObserver>
              </div>
              <!-- end card-body-->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end page -->
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ebInput from "@/components/FormElements/Input.vue";
import { mapGetters, mapActions } from "vuex";
import { getReverseGeoCode } from "@/services/geocode";
import ComponentHeader from "@/components/componentHeader";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ebInput,
    ComponentHeader
  },
  data() {
    return {
      paramsId: null,
      isEditMode: false,
      oldPwd: "",
      newPwd: "",
      cfmPwd: "",
      errorMessages: "",
      hasAddress: false
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "profileUpdate/GetmeTenant",
      tenantLanguage: "tenant/GetTenantLanguage",
      tenantPreferences: "tenant/GetTenantPreferences"
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    }
  },
  methods: {
    ...mapActions({
      changePassword: "profileUpdate/UpdatePassword"
    }),
    async onSubmit() {
      if (this.newPwd == this.cfmPwd) {
        try {
          const payload = {
            currentPassword: this.oldPwd,
            newPassword: this.newPwd
          };
          await this.changePassword(payload);
          this.$swal({
            title: "Success",
            text: "Password updated successfully",
            type: "success"
          });
          this.$router.push("/myaccount/viewprofile");
        } catch (err) {
          console.log(err);
          this.$swal({
            title: "Error!!",
            text: "Failed",
            type: "error"
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "password and confirm password do not match",
          type: "error"
        });
      }
    }
  }
};
</script>
<style scoped>
.card-header:first-child {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 30px 5px !important;
}
.btn-primary {
  background: rgb(114, 124, 245) !important;
  border: none !important;
  border-radius: 2px !important;
  box-shadow: 0px 1px 5px 1px #989ff0 !important;
}
.form-control {
  height: calc(1.5em + 0.75rem + 10px) !important;
}
.card-body {
  margin: 15px !important;
}
.card {
  border: none !important;
  box-shadow: 0px 1px 5px 1px #cdcfea !important;
}
</style>
